<template>
  <div class="modal fade show d-block" tabindex="-1" @click.self="$emit('close')">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{
              isEdit
                ? $t("employee.timesheets.editHoursFor", { date: formattedDate })
                : $t("employee.timesheets.logHoursFor", { date: formattedDate })
            }}
          </h5>
          <button
            type="button"
            class="btn-close"
            :disabled="saving"
            @click="$emit('close')"
          ></button>
        </div>

        <div class="modal-body">
          <!-- Why this day came back to the employee -->
          <div v-if="rejectionReason" class="alert alert-danger py-2">
            <strong>{{ $t("timesheets.rejected") }}:</strong>
            {{ rejectionReason }}
          </div>

          <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

          <div class="mb-3">
            <label class="form-label">{{ $t("common.date") }}</label>
            <input
              type="date"
              class="form-control"
              :value="date"
              :max="today"
              :disabled="isEdit"
              @change="$emit('update:date', $event.target.value)"
            />
          </div>

          <div class="mb-3">
            <label class="form-label">
              {{ $t("employee.timesheets.hoursForDay") }}
              <span class="text-danger">*</span>
            </label>
            <input
              ref="hoursInput"
              type="number"
              class="form-control"
              min="0"
              max="24"
              step="0.5"
              :value="hours"
              @input="$emit('update:hours', $event.target.value)"
            />
            <small class="text-muted">
              {{ $t("employee.timesheets.hoursHelp") }}
            </small>
          </div>

          <div class="mb-3">
            <label class="form-label">{{ $t("timesheets.notes") }}</label>
            <textarea
              class="form-control"
              rows="2"
              :value="notes"
              :placeholder="$t('employee.timesheets.notesPlaceholder')"
              @input="$emit('update:notes', $event.target.value)"
            ></textarea>
          </div>

          <div v-if="payRate" class="alert alert-info py-2 mb-0">
            {{ $t("timesheets.totalAmount") }}:
            <strong>{{ formattedAmount }}</strong>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            :disabled="saving"
            @click="$emit('close')"
          >
            {{ $t("common.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            :disabled="saving"
            @click="$emit('save', false)"
          >
            {{ $t("employee.timesheets.saveDraft") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="saving || !canSubmit"
            @click="$emit('save', true)"
          >
            {{
              saving
                ? $t("employee.timesheets.submitting")
                : isEdit && rejectionReason
                  ? $t("employee.timesheets.resubmit")
                  : $t("employee.timesheets.submitDay")
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DayEntryModal",
  props: {
    date: { type: String, required: true },
    hours: { type: [String, Number], default: 0 },
    notes: { type: String, default: "" },
    isEdit: { type: Boolean, default: false },
    rejectionReason: { type: String, default: null },
    payRate: { type: Number, default: 0 },
    saving: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  emits: ["update:date", "update:hours", "update:notes", "save", "close"],
  computed: {
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    canSubmit() {
      return parseFloat(this.hours) > 0;
    },
    formattedDate() {
      if (!this.date) return "-";
      return new Date(this.date).toLocaleDateString("en-GB");
    },
    formattedAmount() {
      const amount = (parseFloat(this.hours) || 0) * this.payRate;
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.hoursInput && this.$refs.hoursInput.focus());
  },
};
</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
